/**
 * Created by sung.hwang on 9/7/17.
 */
import { Actions } from './actions';

const initialState = {
    textSent: false,
    textSendError: false,
};

export function textMeTheAppReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.CHANGE_PHONE_NUMBER: {
            return {
                ...state,
                phoneNumberFormatted: action.phoneNumber,
            };
        }
        case Actions.SEND_APP_TEXT_SUCCESS: {
            return {
                ...state,
                textSent: true,
                textSendError: false,
            };
        }
        case Actions.SEND_APP_TEXT_ERROR: {
            return {
                ...state,
                textSent: false,
                textSendError: true,
            };
        }
        default: {
            return state;
        }
    }
}
